import React, { useContext, useState } from "react";
import { Title } from "../Header";
import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined";
import RemoveCircleOutlineOutlinedIcon from "@material-ui/icons/RemoveCircleOutlineOutlined";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  makeStyles,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { UserContext } from "./../UserContext";
import BarChartIcon from "@material-ui/icons/BarChart";
import dashboardConfig, {
  dashboardConfigForBasePlan,
  dashboardConfigForOtherPlan,
} from "./../NoTenantDashboard/DomoDashboardConfig";
import { UnavailableFeatureForSuperuser } from "../UnavailableFeature/UnavailableFeatureForSuperuser";

const useStyles = makeStyles(() => ({
  dashboardContainer: {
    maxWidth: 1200,
    marginLeft: "auto",
    marginRight: "auto",
  },
  accordion: {
    "&.MuiAccordionSummary-root, &.MuiAccordionDetails-root": {
      background: "#eceae4",
    },
  },
  accordionContainer: {
    marginBottom: 30,
    "&.MuiAccordion-root, &.MuiAccordionSummary-root": {
      borderRadius: 10,
    },
  },
  heading: {
    fontSize: 20,
    color: "#041E42",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  accordianDetails: {
    width: "100%",
    maxWidth: 1200,
    padding: "10px 60px",
  },
  commentSection: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    gap: 20,
  },
  comment: {
    width: 250,
    height: 300,
    padding: 10,
    fontSize: 16,
    "&:hover": {
      background: "#fff",
      borderTopRightRadius: 30,
      borderBottomLeftRadius: 30,
    },
  },
  icon: {
    color: "#C76100",
  },
}));

const DOMO_BASE_URL = `${process.env.REACT_APP_DOMO_BASE_URL}`;

const NoTenantDashboard = (props) => {
  const { hasBackButton, parentPath, isBasicPlanOrSetup } = props;
  const classes = useStyles();
  const user = useContext(UserContext).user;
  const isPowerUser = user.isPowerUser();
  const idToken = user.getIdToken();
  const ssoExternalID = user.getSSOExternalID();
  const doesSSOIDExist = ssoExternalID !== null && ssoExternalID !== undefined && ssoExternalID !== "" ? true : false;

  let config = dashboardConfig;
  if (isBasicPlanOrSetup !== true) {
    delete config.DASHBOARD_4;
  }

  const keys = Object.keys(config);

  const [expanded, setExpanded] = useState([]);

  const handleChange = (panel) => (event, isExpanded) => {
    if (isExpanded && !expanded.includes(panel)) {
      const newList = [...expanded, panel];
      setExpanded(newList);
    } else {
      const updatedList = expanded.filter((item) => item !== panel);
      setExpanded(updatedList);
    }
  };

  return (
    <>
      <Title
        icon={BarChartIcon}
        titleText={"Financials"}
        hasBackButton={hasBackButton}
        parentPath={parentPath}
      />
      <div className={classes.dashboardContainer}>
        {keys.map((key, index) => {
          const { title, subtitles, pageID } = dashboardConfig[key];
          return (
            <Accordion
              expanded={expanded.includes(`panel-${index}`)}
              onChange={handleChange(`panel-${index}`)}
              className={classes.accordionContainer}
            >
              <AccordionSummary
                expandIcon={
                  expanded.includes(`panel-${index}`) ? (
                    <RemoveCircleOutlineOutlinedIcon
                      style={{ color: "#C76100" }}
                    />
                  ) : (
                    <AddCircleOutlineOutlinedIcon
                      style={{ color: "#C76100" }}
                    />
                  )
                }
                aria-controls={`panel-${index}a-content`}
                id={`panel-${index}a-header`}
                className={classes.accordion}
              >
                <Typography className={classes.heading}>{title}</Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordion}>
                {(doesSSOIDExist && !isPowerUser) ? (
                  <div className={classes.accordianDetails}>
                    <iframe
                      src={`${DOMO_BASE_URL}/${ssoExternalID}?token=${idToken}&page=${pageID}`}
                      height="600"
                      width="100%"
                      title="description"
                    ></iframe>

                    {subtitles && subtitles.length !== 0 && <hr />}
                    <div className={classes.commentSection}>
                      {subtitles.map((subtitle) => {
                        const comment = subtitle
                          .split("\n")
                          .map((str) => <p>{str}</p>);
                        return <div className={classes.comment}>{comment}</div>;
                      })}
                    </div>
                  </div>
                ) : (
                  <UnavailableFeatureForSuperuser />
                )}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </div>
    </>
  );
};

export default NoTenantDashboard;
